module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\"><path fill=\"#9ECAFF\" fill-rule=\"nonzero\" d=\"M17.74 1.26c-.19-.08-4.64-1.78-8.11.02-2.75 1.42-7.58.35-8.81.04V.4A.4.4 0 0 0 .4 0 .4.4 0 0 0 0 .4V23.6a.4.4 0 1 0 .82 0v-9.45c.93.23 2.95.65 5.06.65 1.45 0 2.94-.2 4.13-.82 3.13-1.62 7.39 0 7.43.02.13.05.27.04.38-.04a.4.4 0 0 0 .18-.33v-12a.4.4 0 0 0-.26-.37zm-.56 11.8c-1.33-.4-4.76-1.23-7.55.22-2.75 1.42-7.58.35-8.81.04V2.15c1.57.38 6.29 1.34 9.19-.17 2.69-1.39 6.2-.4 7.17-.07v11.16z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/flag.svg
// module id = 9UjI
// module chunks = 5